import styled from 'styled-components';
import Row from 'antd/es/row';
import Affix from 'antd/es/affix';

export const ItemsRow = styled(Row)<{ $notFound?: boolean }>`
  width: 100%;
  margin: 0 auto 0 auto;
  display: grid !important;
  grid-template-columns: ${({ $notFound }) =>
    $notFound ? '420px 0' : '260px 960px'};
  justify-content: center;
  padding: 0 100px;
  gap: 0 20px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex !important;
    padding: 0;
    overflow-x: hidden;
  }
`;

export const ItemsRowWrapper = styled.div`
  width: 100%;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin-left: 0;
    margin-top: 0;
  }
`;

export const SearchWrapper = styled.div<{ sticky?: boolean }>`
  margin: 0 auto;
  margin-top: ${({ sticky }) => (sticky ? '0' : ' 20px')};
  padding: ${({ sticky }) => (sticky ? '10px 0' : '0')};
  z-index: 999999;
  position: ${({ sticky }) => (sticky ? 'fixed' : 'unset')};
  width: ${({ sticky }) => (sticky ? '100vw' : 'fit-content')};
  left: 0;
  top: ${({ sticky }) => (sticky ? '0' : '-100px')};
  transition: top 0.3s;
  display: flex;
  background-color: ${({ sticky, theme }) =>
    sticky ? theme.palette.white : 'transparent'};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-top: 0;
  }
  border-bottom: 2px solid ${({ theme }) => theme.palette.white};
  padding-bottom: 32px;
  margin-bottom: 24px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-bottom: 0;
    margin-bottom: 0;
    border-bottom: 0;
  }
`;

export const SearchWrapperHidden = styled.div`
  margin: 0 auto;
  margin-top: 20px;
  width: 100%;
  height: 78px;
`;

export const SearchWrapperContent = styled.div<{ sticky?: boolean }>`
  max-width: 1240px;
  ${({ sticky }) => sticky && 'width: 1240px; '};
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;
export const StickyLogoBox = styled.div`
  display: flex;
  align-items: center;
  margin-right: auto;
  @media only screen and (max-width: 1100px) {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }

  img {
    height: 30px;
  }
`;

export const StickyText = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primaryBrand};
  margin-left: 20px;
`;

export const NotFoundWrapper = styled.div`
  width: 100%;

  padding: 100px 0;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    padding: 50px 0;
  }
`;

export const ListingItemContainer = styled.div`
  width: 100%;
  height: auto;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 12px;
  }
`;

export const ListingItemCardWrapper = styled.div`
  margin-top: 12px;
  width: 100%;
`;

export const ListingCampaignBanner = styled.div`
  margin-bottom: 20px;
  width: 960px;
  height: 285px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    max-width: 1003px;
    width: 100%;
    margin: 0 auto 40px auto;
    & > div {
      padding: 0 !important;
    }
  }

  @media (max-width: 1019px) {
    max-width: 660px;
    width: 100%;
    margin: 0 auto 40px auto;
  }

  @media only screen and (max-width: 690px) {
    max-width: 93%;
    height: 401px;
  }
`;

export const LoadMoreButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0;
`;
export const LoadMoreButton = styled.button`
  padding: 18px 40px;
  cursor: pointer;
  border-radius: 2px;
  border: solid 1px ${(p) => p.theme.palette.eclipse};
  background-color: white;
  width: 220px;
  line-height: 22.001px;

  &:disabled {
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
`;

export const ResponsiveBox = styled.div`
  width: 100%;
  height: 136px;
  padding: 15px 15px 15px 20px;
  border-radius: 2px;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
`;

export const ResponsiveBoxAffix = styled(Affix)<{ sticky?: boolean }>`
  .setur-affix {
    z-index: 12 !important;
    position: ${({ sticky }) => (sticky ? 'fixed' : 'static')} !important;
  }
`;

export const ResponsiveSearchBoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ResponsiveSearchBoxItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const ResponsiveSearchBoxLabel = styled.span`
  margin: 0 0 0 5px;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.matterHorn};
`;

export const ResponsiveSearchBoxLabelBig = styled.span`
  font-size: 18px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.primaryBrand};
  display: inline-block;
  margin-bottom: 10px;
`;

export const ResponsiveSearchBoxEdit = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const ResponsiveSearchBoxEditLabel = styled.span`
  margin: 1px 5px 1px 0;
  font-size: 14px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.eclipse};
`;

export const ResponsiveSearchBoxSubLabel = styled.span`
  font-weight: normal;
  display: inline-block;
  margin-left: 5px;
  color: ${({ theme }) => theme.palette.primaryBrand};
`;

export const SkeletonItemsWrapper = styled.div`
  width: 960px;
  display: grid;
  margin-top: 1.4rem;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    grid-template-columns: repeat(auto-fit, minmax(310px, 1fr));
    justify-items: center;
  }
`;

export const HotelSearchBarWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.palette.white};
  padding: 24px 0px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey300};
`;

export const MetaTitle = styled.span<{ bold?: boolean }>`
  font-size: 20px;
  font-weight: ${({ bold }) => (bold ? '600' : '400')};
  color: ${({ theme }) => theme.palette.grey1100};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 14px;
  }
`;
